import { render, staticRenderFns } from "./TopicSelector.vue?vue&type=template&id=75588059"
import script from "./TopicSelector.vue?vue&type=script&lang=js"
export * from "./TopicSelector.vue?vue&type=script&lang=js"
import style0 from "./TopicSelector.vue?vue&type=style&index=0&id=75588059&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports